import AnnonceSlider from "./AnnnonceSLider";

export const RenderAnnonceImage = (annonce) => {
  const { categorie } = annonce;

  switch (categorie) {
    case "travail":
      return (
        <>
          <img className="annonce-image" src="/img/Travail.png" alt="imgtravail" />
        </>
      );
    case "formation":
      return (
        <>
          <img className="annonce-image" src="/img/Formation.png" alt="imgformation" />
        </>
      );
    case "artisanat":
      return (
        <>
          <img className="annonce-image" src="/img/Artisanat.png" alt="imgartisanat" />
        </>
      );
    default:
      return <AnnonceSlider images={annonce.images || {}} />;
  }
};
